module.exports = __webpack_public_path__ + "static/media/vr-logo512.2117f8bc.png";